import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getTiposMultaBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("tiposMulta/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTiposMulta(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
                dados.pagina = 1;
                dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("tiposMulta/access/listar", dados).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    getTipoMulta(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("tiposMulta/access/obter", {ID_TIPO_DE_MULTA: dados.id, componente: dados.componente}).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    deleteTipoMulta(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("tiposMulta/access/excluir", {ID_TIPO_DE_MULTA: dados.id, componente: dados.componente}).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    },
    postTipoMulta(context, dados) {
        return new Promise(resolve => {
                if (JwtService.getToken()) {
                        ApiService.setHeader();
                        ApiService.post("tiposMulta/access/salvar", dados).then(({ data }) => {
                                resolve(data);
                        });
                }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};